import FieldConfig from "../../../proto/field-config";
import FieldTimeSpent from "../../../generic/datetime/time-spent/time-spent";

export default class FieldTaskTimeReported extends FieldTimeSpent {



    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Task time reported";
        this.label      = "Time reported";
        this.icon       = 'i5-time-reported'
        this.placeholderValueExample = "Enter time spent e.g. 3h 20m"
        this.hasStartEnd                = true

        this.canBeBillable  = true      // !!!


        this.presetMinutes = [
            {value:15, label: "15"},
            {value:30, label: "30"},
            {value:45, label: "45"}
        ]

        this.presetHours = [
            {value: 60, label: "1"},
            {value: 120, label: "2"},
            {value: 180, label: "3"},
            {value: 240, label: "4"},
            {value: 300, label: "5"},
            {value: 360, label: "6"},
            {value: 420, label: "7"},
            {value: 480, label: "8"}
        ]
    }

}